import React, { useState } from 'react';
import { MessageCircle } from 'lucide-react';
import FeedbackModal from './FeedbackModal';
import { useAuth } from '../../context/AuthContext';
var FeedbackButton = function () {
    var _a = useState(false), isModalOpen = _a[0], setIsModalOpen = _a[1];
    var isAuthenticated = useAuth().isAuthenticated;
    // ✅ Não renderiza se não estiver autenticado
    if (!isAuthenticated) {
        return null;
    }
    return (React.createElement(React.Fragment, null,
        React.createElement("button", { onClick: function () { return setIsModalOpen(true); }, className: "px-2 py-1 bg-gradient-to-r from-green-500 to-blue-500 hover:from-green-600 hover:to-blue-600 \n                rounded-full shadow-lg hover:scale-110 active:scale-95 transition-all duration-200 flex items-center justify-center group relative z-10", title: "Enviar Feedback" },
            React.createElement(MessageCircle, { size: 15, className: "text-white group-hover:rotate-12 transition-transform" }),
            React.createElement("span", { className: "hidden md:inline text-xs" }, " \u00A0 Feedback")),
        React.createElement(FeedbackModal, { isOpen: isModalOpen, onClose: function () { return setIsModalOpen(false); } })));
};
export default FeedbackButton;
